<div class="confirmation-overlay" *ngIf="isVisible">
  <div class="confirmation-backdrop" (click)="onCancel()"></div>

  <div class="confirmation-modal">
    <div class="confirmation-header">
      <h2>Confirmar Solicitação</h2>
    </div>

    <div class="confirmation-body">
      <p class="confirmation-description">
        Revise os dados antes de enviar:
      </p>

      <div class="confirmation-form-name">
        <span class="form-label">Tipo:</span>
        <span class="form-value">{{ formName }}</span>
      </div>

      <div class="confirmation-items">
        <div class="confirmation-item" *ngFor="let item of summaryItems">
          <span class="item-label">{{ item.label }}:</span>
          <span class="item-value">{{ item.value }}</span>
        </div>
      </div>

      <div class="confirmation-attachments" *ngIf="attachmentCount > 0">
        <span class="item-label">Anexos:</span>
        <span class="item-value">{{ attachmentCount }} arquivo(s)</span>
      </div>
    </div>

    <div class="confirmation-footer">
      <button class="btn-cancel" (click)="onCancel()">Cancelar</button>
      <button class="btn-confirm" (click)="onConfirm()">
        Confirmar e Enviar
      </button>
    </div>
  </div>
</div>
